<template>
    <div class="profile-section">

        <section class="toolbar">
            <div class="toolbar-container">
                <router-link id="back-button-inspection" v-bind:to="'/operator/pre-log-summary?selected_date='+selectedDate+'&from_date=' + fromDate + '&to_date=' + toDate"><img src="/static/images/back.png"></router-link>
                <h1>New Inspection</h1>
            </div>
        </section>
        <div class="clearfix"></div>
        <section class="tab-container">
            <form class="form-inline" id="inspectionForm" enctype="multipart/form-data">
                <input id="id" name="id" type="hidden" v-model="id">
                <div id="custom-tab">
                    <ul class="nav nav-pills">
                        <li class="active">
                            <a href="#general" data-toggle="tab">General</a>
                        </li>
                        <li>
                            <a id="defects_tab" href="#defects" data-toggle="tab">Defects</a>
                        </li>
                        <li>
                            <a href="#sign" data-toggle="tab" id="sign_tab">Sign</a>
                        </li>
                    </ul>
                    <div class="tab-content clearfix">
                        <div class="tab-pane active" id="general">

                            <div class="group">
                                <input type="text" id="vin" name="vin" v-model="vin" readonly>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label for="odometer">VIN:</label>
                            </div>

                            <div id="select-inspection-time" class="group time-field">
                                <input type="text" id="time" name="time" :value="inspectionTime">
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label for="time">Time:</label>
                            </div>
                            <div class="group">
                                <input type="text" readonly id="company" name="company" :value="company">
                                <input type="hidden" id="company_id" name="company_id" :value="companyId">
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label for="company">Carrier/Company Name:</label>
                            </div>
                            <div class="group location-field">
                                <input type="text" readonly id="location_name" name="location_name" :value="locationName" v-on:click="getLocationConstant()">
                                <input type="hidden" id="longitude" name="longitude" :value="longitude">
                                <input type="hidden" id="latitude" name="latitude" :value="latitude">
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label for="lname">Location:</label>
                            </div>
                            <div class="group">
                                <input type="text" id="odometer" name="odometer" v-model="odometer">
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label for="odometer">Odometer:</label>
                            </div>
                            <div class="group">
                                <div class="select-style">
                                    <select name="inspection_type" :value="inspectionType" v-model="inspectionType" id="inspection_type" class="form-control">
                                        <option id="inspection-type-none" value="none" selected>None</option>
                                        <option id="inspection-type-pretrip" value="pre-trip">Pre-Trip</option>
                                        <option id="inspection-type-posttrip" value="post-trip">Post-Trip</option>
                                    </select>
                                </div>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <label for="inspectioin_type">Inspection Type:</label>
                            </div>

                        </div>
                        <div class="tab-pane" id="defects">

                            <div id="vehicle_defect_block" v-show="!vehicleDefectsList && !trailerDefectsList" class="defects-vehicles-block">
                                <div class="defects-vehicles-number">
                                    Vehicle 367203
                                </div>
                                <template v-if="vehicleDefects.length > 0">                                    
                                    <ul>
                                        <template v-for="(vDefects, index) in vehicleDefects" v-if="vDefects.selected == 1">
                                                
                                            <li>
                                                <div class="details-block">
                                                    <div class="details-label first-label">{{ vDefects.name }}</div>
                                                    <template v-if="vDefects.def_type != 'none'">
                                                        <div class="details-notes">
                                                            <template v-if="vDefects.def_type == 'major'">
                                                                <span class="major">Major</span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="minor">Minor</span>
                                                            </template>
                                                        </div>
                                                    </template>
                                                </div>
                                                <template v-if="vDefects.note != ''">
                                                    <div class="details-block">
                                                        <div class="details-label">Defect Details</div>
                                                        <div class="details-notes">{{ vDefects.note }}</div>
                                                    </div>
                                                </template>  
                                                <template v-if="vDefects.image != 'default' && vDefects.image != ''">
                                                    <div class="details-block">
                                                        <div class="details-img">
                                                            <img :src="$config.API+'/'+vDefects.image">
                                                        </div>
                                                    </div>
                                                </template>                                                        
                                            </li>
                                                
                                        </template>
                                    </ul>    
                                    <div class="defects-vehicles-details hide">
                                        <img src="/static/images/inspection-gray.png">
                                        <span>No Defects Found</span>
                                    </div>                                
                                </template>
                                <template v-else>
                                    <ul></ul>
                                    <div class="defects-vehicles-details">
                                        <img src="/static/images/inspection-gray.png">
                                        <span>No Defects Found</span>
                                    </div>                                    
                                </template>

                                <div class="inspection-btn-container">
                                    <a id="vehicle-defect-editor" href="javascript:void(0)" v-on:click="vehicleDefectsList=true" class="inspection-btn">Add/Remove Vehicle Defects</a>
                                </div>
                            </div>

                            <div id="trailer_defect_block" v-show="!vehicleDefectsList && !trailerDefectsList" class="defects-vehicles-block">

                                <div class="defects-vehicles-input-block">
                                    <div class="group">
                                        <input type="text" name="trailer_numbers" required>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <label>Trailers Numbers</label>
                                    </div>
                                </div>
                                <template v-if="trailerDefects.length > 0">                                    
                                    <ul>
                                        <template v-for="(tDefects, index) in trailerDefects" v-if="tDefects.selected == 1">
                                            <li>
                                                <div class="details-block">
                                                    <div class="details-label first-label">{{ tDefects.name }}</div>
                                                    <template v-if="tDefects.def_type != 'none'">
                                                        <div class="details-notes">
                                                            <template v-if="tDefects.def_type == 'major'">
                                                                <span class="major">Major</span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="minor">Minor</span>
                                                            </template>
                                                        </div>
                                                    </template>
                                                </div>
                                                <template v-if="tDefects.note != ''">
                                                    <div class="details-block">
                                                        <div class="details-label">Defect Details</div>
                                                        <div class="details-notes">{{ tDefects.note }}</div>
                                                    </div>
                                                </template>  
                                                <template v-if="tDefects.image != 'default'  && tDefects.image != ''">
                                                    <div class="details-block">
                                                        <div class="details-img">
                                                            <img :src="$config.API+'/'+tDefects.image">
                                                        </div>
                                                    </div>
                                                </template>                                                    
                                            </li>
                                                
                                        </template>
                                    </ul>  
                                    <div class="defects-vehicles-details hide">
                                        <img src="/static/images/inspection-gray.png">
                                        <span>No Defects Found</span>
                                    </div>                                     
                                </template>
                                <template v-else>
                                    <ul></ul>
                                    <div class="defects-vehicles-details">
                                        <img src="/static/images/inspection-gray.png">
                                        <span>No Defects Found</span>
                                    </div>                                    
                                </template>
                                
                                <div class="inspection-btn-container">
                                    <a id="trailer-defect-editor" href="javascript:void(0)" v-on:click="trailerDefectsList=true" class="inspection-btn">Add/Remove Vehicle Defects</a>
                                </div>
                            </div>

                            <section v-show="vehicleDefectsList" class="vehicle-defects vehicle-defects-checkbox-container">
                                <div v-for="(vDefects, index) in vehicleDefects">
                                    <div v-if="vDefects.selected == 1">
                                        <div class="form-group">
                                            <div class="checkbox">
                                                <label data-toggle="collapse" :data-target="`#vDef-${vDefects.id}`" aria-expanded="true" :aria-controls="`vDef-${vDefects.id}`">
                                                    <input type="checkbox" checked name="defCheck[]" v-bind:value="`${vDefects.id}`" :data-defname="`${vDefects.name}`" /> {{ vDefects.name }}
                                                </label>
                                            </div>
                                        </div>
                                        <div v-bind:id="`vDef-${vDefects.id}`" aria-expanded="true" class="collapse in">

                                            <div class="well">
                                                <section class="tab-container">
                                                    <div class="group">
                                                        <div class="select-style">
                                                            <select class="v-def-trip-type" v-model="vDefects.def_type" v-bind:name="`defType-${vDefects.id}`">
                                                                <option selected value="none">None</option>
                                                                <option value="major">Major</option>
                                                                <option value="minor">Minor</option>
                                                            </select>
                                                        </div>
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Defect Type</label>
                                                    </div>

                                                    <div class="group">
                                                        <input type="text" class="v-def-note" v-model="vDefects.note" v-bind:name="`defNote-${vDefects.id}`">
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Enter Notes</label>
                                                    </div>

                                                    <div v-if="vDefects.image != '' && vDefects.image != 'default'">
                                                        <div class="details-block">
                                                            <div class="details-img">
                                                                <template v-if="!vDefects.local_image">
                                                                    <img :src="$config.API+'/'+vDefects.image_path" v-bind:id="`defImage-${vDefects.id}`">
                                                                </template>
                                                                <template v-else>
                                                                    <img :src="vDefects.image" v-bind:id="`defImage-${vDefects.id}`">
                                                                </template>
                                                            </div>
                                                            <input type="hidden" :value="vDefects.image_path" v-bind:name="`defSelectedImage-${vDefects.id}`"/>
                                                            <input type="button" v-on:click="updateDefectVars(vDefects)" value="Remove Image"/>
                                                        </div>
                                                    </div>    
                                                    <div v-else><!--="vDefects.image == 'default'">-->
                                                        <div class="well-btn" ref="sample">
                                                            <a href="#"><img src="/static/images/camera.png"> Add Photo</a>
                                                        </div>
                                                        <!--<div class="details-img">
                                                            <img :src="vDefects.image" v-bind:id="`defImage-${vDefects.id}`">
                                                        </div>-->
                                                        <input v-bind:name="`defImage-${vDefects.id}`" type="file" @change="onFileChange($event,vDefects)">
                                                    </div>                                                 
                                                </section>

                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="form-group">
                                            <div class="checkbox">
                                                <label data-toggle="collapse" :data-target="`#vDef-${vDefects.id}`" aria-expanded="false" :aria-controls="`vDef-${vDefects.id}`">
                                                    <input type="checkbox" name="defCheck[]" v-bind:value="`${vDefects.id}`" :data-defname="`${vDefects.name}`" /> {{ vDefects.name }}
                                                </label>
                                            </div>
                                        </div>
                                        <div v-bind:id="`vDef-${vDefects.id}`" aria-expanded="false" class="collapse">

                                            <div class="well">
                                                <section class="tab-container">
                                                    <div class="group">
                                                        <div class="select-style">
                                                            <select class="v-def-trip-type" v-bind:name="`defType-${vDefects.id}`">
                                                                <option selected value="none">None</option>
                                                                <option value="major">Major</option>
                                                                <option value="minor">Minor</option>
                                                            </select>
                                                        </div>
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Defect Type</label>
                                                    </div>

                                                    <div class="group">
                                                        <input type="text" class="v-def-note" v-bind:name="`defNote-${vDefects.id}`">
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Enter Notes</label>
                                                    </div>
                                                    <!--<template v-show="vDefects.image != '' && vDefects.show_image_control == false" >-->
                                                    <div v-if="vDefects.image != 'default' && vDefects.image != ''">
                                                        <div class="details-img">
                                                        <!-- Just for testing purpose to see image content -->
                                                        <!--<label>{{vDefects.image}}</label>-->
                                                            <img v-bind:id="`defImage-${vDefects.id}`" :src="vDefects.image" >
                                                        </div>
                                                        <input type="button" v-on:click="updateDefectVars(vDefects)" value="Remove Image"/>
                                                    </div>
                                                    <div v-else><!--="vDefects.image == 'default'">-->
                                                         <div class="well-btn">
                                                            <a href="#"><img src="/static/images/camera.png"> Add Photo</a>
                                                        </div>
                                                        <input v-bind:name="`defImage-${vDefects.id}`" v-bind:id="`defImage-${vDefects.id}`" type="file" @change="onFileChange($event,vDefects)">
                                                    </div>
                                                    <!--<image-compressor v-bind:name="`defImage-${vDefects.id}`" :done="getFiles" :scale="scale" :quality="quality" :ref="`compressor_${vDefects.id}`"></image-compressor>-->
                                                </section>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>

                            <section v-show="trailerDefectsList" class="trailer-defects vehicle-defects-checkbox-container">
                                <div v-for="(tDefects, index) in trailerDefects">
                                    <div v-if="tDefects.selected == 1">
                                        <div class="form-group">
                                            <div class="checkbox">
                                                <label data-toggle="collapse" :data-target="`#tDef-${tDefects.id}`" aria-expanded="true" :aria-controls="`tDef-${tDefects.id}`">
                                                    <input type="checkbox" checked name="defCheck[]" :data-defname="`${tDefects.name}`" v-bind:value="`${tDefects.id}`" /> {{ tDefects.name }}
                                                </label>
                                            </div>
                                        </div>
                                        <div v-bind:id="`tDef-${tDefects.id}`" aria-expanded="true" class="collapse in">

                                            <div class="well">
                                                <section class="tab-container">
                                                    <div class="group">
                                                        <div class="select-style">
                                                            <select class="t-def-trip-type" v-model="tDefects.def_type" v-bind:name="`defType-${tDefects.id}`" :value="tDefects.def_type">
                                                                <option selected value="none">None</option>
                                                                <option value="major">Major</option>
                                                                <option value="minor">Minor</option>
                                                            </select>
                                                        </div>
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Defect Type</label>
                                                    </div>

                                                    <div class="group">
                                                        <input type="text" class="v-def-note" v-model="tDefects.note" v-bind:name="`defNote-${tDefects.id}`">
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Enter Notes</label>
                                                    </div>
                                                    <div v-if="tDefects.image != '' && tDefects.image != 'default'">
                                                        <div class="details-block">
                                                            <div class="details-img">
                                                                <template v-if="!tDefects.local_image">
                                                                    <img :src="$config.API+'/'+tDefects.image_path" v-bind:id="`defImage-${tDefects.id}`">
                                                                </template>
                                                                <template v-else>
                                                                    <img :src="tDefects.image" v-bind:id="`defImage-${tDefects.id}`">
                                                                </template>
                                                            </div>
                                                            <input type="hidden" :value="tDefects.image_path" v-bind:name="`defSelectedImage-${tDefects.id}`"/>
                                                            <input type="button" v-on:click="updateDefectVars(tDefects)" value="Remove Image"/>
                                                        </div>
                                                    </div>    
                                                    <div v-else><!--="tDefects.image == ''">-->
                                                        <div class="well-btn" ref="sample">
                                                            <a href="#"><img src="/static/images/camera.png"> Add Photo</a>
                                                        </div>
                                                        <input v-bind:name="`defImage-${tDefects.id}`" type="file" @change="onFileChange($event,tDefects)">
                                                    </div>  
                                                </section>

                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="form-group">
                                            <div class="checkbox">
                                                <label data-toggle="collapse" :data-target="`#tDef-${tDefects.id}`" aria-expanded="false" :aria-controls="`tDef-${tDefects.id}`">
                                                    <input type="checkbox" name="defCheck[]" :data-defname="`${tDefects.name}`" v-bind:value="`${tDefects.id}`" /> {{ tDefects.name }}
                                                </label>
                                            </div>
                                        </div>
                                        <div v-bind:id="`tDef-${tDefects.id}`" aria-expanded="false" class="collapse">

                                            <div class="well">
                                                <section class="tab-container">
                                                    <div class="group">
                                                        <div class="select-style">
                                                            <select class="t-def-trip-type" v-bind:name="`defType-${tDefects.id}`">
                                                                <option selected value="none">None</option>
                                                                <option value="major">Major</option>
                                                                <option value="minor">Minor</option>
                                                            </select>
                                                        </div>
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Defect Type</label>
                                                    </div>

                                                    <div class="group">
                                                        <input type="text" class="v-def-note" v-bind:name="`defNote-${tDefects.id}`">
                                                        <span class="highlight"></span>
                                                        <span class="bar"></span>
                                                        <label>Enter Notes</label>
                                                    </div>
                                                    <div v-if="tDefects.image != 'default'  && tDefects.image != ''">
                                                        <div class="details-img">
                                                            <img v-bind:id="`defImage-${tDefects.id}`" :src="tDefects.image" >
                                                        </div>
                                                        <input type="button" v-on:click="updateDefectVars(tDefects)" value="Remove Image"/>
                                                    </div>
                                                    <div v-else><!--="tDefects.image == ''">-->
                                                         <div class="well-btn">
                                                            <a href="#"><img src="/static/images/camera.png"> Add Photo</a>
                                                        </div>
                                                        <input v-bind:name="`defImage-${tDefects.id}`" v-bind:id="`defImage-${tDefects.id}`" type="file" @change="onFileChange($event,tDefects)">
                                                    </div>

                                                </section>

                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </section>

                        </div>
                        <div class="tab-pane" id="sign">

                            <div class="sign-text" v-show="!areDefectsAdded">Vehicle Condition Satisfactory</div>
                            <div v-show="areDefectsAdded">
                                <div class="checkbox123">
                                    <label>
                                        <input type="radio" value="1" name="opt_defects" id="chk_defects_corrected"  :checked="defect_correction == 1"/>
                                        <!--<span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>-->
                                        Defects Corrected
                                    </label>
                                </div>
                                <div class="checkbox123">
                                    <label>
                                        <input type="radio" value="0" name="opt_defects" id="chk_need_not_corrected" :checked="defect_correction == 0"/>
                                        <!--<span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>-->
                                        Defects Need Not Be Corrected
                                    </label>
                                </div>
                            </div>
                            <div class="defects-vehicles-block">
                                <div class="defects-vehicles-number">
                                    Driver Signature
                                </div>

                                <div class="inspection-btn-container" v-show="!showDriverSign" v-on:click="showDriverSign = !showDriverSign">
                                    <a href="#" class="inspection-btn">Sign Inspection Report</a>
                                </div>

                                <div class="form-group" v-show="showDriverSign">
                                    <!--<textarea class="form-control" rows="5" id="comment"></textarea>-->
                                    <canvas id="signature-pad-driver" class="signature-pad col-md-12" height=200></canvas>
                                   
                                </div>
                            </div>

                             <label for="comment" class="pull-right" id="driver-sign-clear" v-on:click="signaturePadDriver.clear()">Clear Signature</label>

                            <div class="defects-vehicles-block" v-show="areDefectsAdded">
                                <div class="defects-vehicles-number">
                                    Mechanic Signature
                                </div>

                                <div class="inspection-btn-container" v-show="!showMechanicSign" v-on:click="showMechanicSign = !showMechanicSign">
                                    <a href="#" class="inspection-btn">Sign Inspection Report</a>
                                </div>

                                <div class="form-group" v-show="showMechanicSign">
                                    <!--<textarea class="form-control" rows="5" id="comment"></textarea>-->
                                    <canvas id="signature-pad-mechanic" class="signature-pad col-md-12" height=200></canvas>
                                    <label for="comment" class="pull-right" id="mechanic-sign-clear" v-on:click="signaturePadMechanic.clear()">Clear Signature</label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <section class="submit-section">
                    <button id="save-inspection" v-show="!vehicleDefectsList && !trailerDefectsList" type="button" v-on:click="addInspectionDetail()" class="btn btn-default">Save</button>
                    <router-link id="cancel-save-inspection" v-bind:to="'/operator/pre-log-summary?selected_date='+selectedDate" tag="button" v-show="!vehicleDefectsList && !trailerDefectsList" class="btn btn-default">Cancel</router-link>
                    <button id="defects-done-button" v-show="vehicleDefectsList || trailerDefectsList" v-on:click="selectDefects()" type="button" class="btn btn-default">Done</button>
                </section>
            </form>
        </section>

    </div>
</template>

<script>

import SignaturePad from 'signature_pad';

export default {
    name: "inspection",
    data: () => ({
        id: "",
        inspectionType: "none",
        locationName: "",
        longitude: "",
        latitude: "",
        showDriverSign: false,
        showMechanicSign: false,
        areDefectsAdded: false,
        company: "",
        companyId: "",
        time: "",
        odometer: "",
        selectedDate: "",
        vehicleDefectsList: false,
        trailerDefectsList: false,
        vehicleDefects: [],
        trailerDefects: [],
        selVehDefects: [],
        selTraDefects: [],
        signaturePadDriver: null,
        signaturePadMechanic: null,
        signaturePadSign: null,
        inspectionTime: "",
        odometer: "",
        img: "",
        scale: 100,
        quality: 50,
        originalSize: true,
        original: {},
        removedImagePaths:[],
        formData:null,
        defect_correction:-1,
        fromDate:"",
        toDate:"",
        vin:"",
        //image: {},
    }),
    created: function() {
        let geoLocation = document.createElement('script')
        geoLocation.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAxR9iECiPUyY6Tn0kAU2SFturhVMbOyIM')
        document.head.appendChild(geoLocation)
    },
    mounted: function() {
        //var form = $('#inspectionForm')[0];
        //this.formData = new FormData(form);
        this.selectedDate = this.$route.query.selected_date;
        this.fromDate = this.$route.query.from_date;
        this.toDate = this.$route.query.to_date;
        //var self = this;
        this.signaturePadDriver = new SignaturePad(document.getElementById("signature-pad-driver"), {
                backgroundColor: "rgba(255, 255, 255, 0)",
                penColor: "rgb(0, 0, 0)"
            }
        );
        this.signaturePadMechanic = new SignaturePad(document.getElementById("signature-pad-mechanic"), {
                backgroundColor: "rgba(255, 255, 255, 0)",
                penColor: "rgb(0, 0, 0)"
            }
        );
        /*window.addEventListener("resize", document.getElementById("signature-pad-driver"));
        self.resizeCanvas(document.getElementById("signature-pad-driver"));
        window.addEventListener("resize", document.getElementById("signature-pad-mechanic"));
        self.resizeCanvas(document.getElementById("signature-pad-mechanic"));*/
        this.getUserAgent();
        this.call();
        //this.readUrl("","");
        var self = this;
        $('#time').datetimepicker({
            useCurrent: true,
            format: 'LT',
            ignoreReadonly: true,
            // debug: true,
        }).on('dp.change', function(e){
            self.inspectionTime = $('#time').val();
        });

        /*$('#time').change(function () {
             console.log($('#date-daily').val());
        });*/
        if( self.userAgent == "vtrleld_app" ) {
            Native.disableSwipeRefresh();
        }
    },
    methods: {
        getUserAgent : function() {
            this.userAgent = navigator.userAgent;
            console.log("UserAgent : " +  this.userAgent);
        },
        selectDefects: function() {

            this.vehicleDefectsList = false
            this.trailerDefectsList = false
            
            
            // $("#vechicle_defect_block .defects-vehicles-details").show()
            // $("#trailer_defect_block .defects-vehicles-details").show()

            if ($('.vehicle-defects [name="defCheck[]"]:checked').length == 0) {
                $("#vehicle_defect_block .defects-vehicles-details").removeClass("hide")
                $("#vehicle_defect_block ul").empty();
            }
            if ($('.trailer-defects [name="defCheck[]"]:checked').length == 0) {                
                $("#trailer_defect_block .defects-vehicles-details").removeClass("hide")
                $("#trailer_defect_block ul").empty();
            }


            if ($('.vehicle-defects:visible').length > 0) {
                if ($('.vehicle-defects [name="defCheck[]"]:checked').length > 0) {
                    $("#vehicle_defect_block ul").empty();
                    this.areDefectsAdded = true
                }
                //get selected checkbox               
                $('.vehicle-defects input[name="defCheck[]"]:checked').each(function() {
                    $("#vehicle_defect_block .defects-vehicles-details").addClass("hide")
                    //console.log(this.value);
                    var defType = $("select[name=defType-" + this.value + "]").val();
                    var defNote = $("input[name=defNote-" + this.value + "]").val();

                    var defName = $(this).data('defname');
                    var defImageSrc = "";
                    if(document.getElementById("defImage-" + this.value) != null) {
                        defImageSrc = document.getElementById("defImage-" + this.value).src;
                        console.log("Image Source : " + defImageSrc);
                    }

                    var defTypeClass = "none";
                    if (defType == "minor") {
                        defTypeClass = "minor";
                        defType = "Minor";
                    } else if (defType == "major") {
                        defTypeClass = "major";
                        defType = "Major";
                    }

                    var html = '<li>' +
                        '<div class="details-block">' +
                        '<div class="details-label first-label">' + defName + '</div>';
                    if (defTypeClass != "none") {
                        html += '<div class="details-notes">' +
                            '<span class="' + defTypeClass + '">' + defType + '</span>' +
                            '</div>';
                    }

                    html += '</div>';
                    if (defNote != "") {
                        html += '<div class="details-block">' +
                            '<div class="details-label">Defect Details</div>' +
                            '<div class="details-notes">' +
                            defNote
                        '</div>' +
                            '</div>';
                    }
                    
                    if(defImageSrc != "" && !defImageSrc.includes("default")) {
                        html += '<div class="details-block">' +
                            '<div class="details-img">'+
                                '<img src="'+defImageSrc+'">'+
                                '</div>' +
                            '</div>';                        
                    }

                    html += '</li>';
                    //append data into vehicle block
                    $("#vehicle_defect_block ul").append(html)

                    /*if (defImageInput.files && defImageInput.files[0]) {
                        var reader = new FileReader();

                        reader.onload = function(e) {
                            $("#vechicle_defect_block ul #defImageSrc-" + this.value).attr('src', e.target.result);
                        }

                        reader.readAsDataURL(defImageInput.files[0]);
                    }*/
                });
            }
            if ($('.trailer-defects:visible').length > 0) {
                if ($('.trailer-defects [name="defCheck[]"]:checked').length > 0) {
                    $("#trailer_defect_block ul").empty();
                    this.areDefectsAdded = true
                }
                //get selected checkbox               
                $('.trailer-defects input[name="defCheck[]"]:checked').each(function() {
                    $("#trailer_defect_block .defects-vehicles-details").addClass("hide")
                    //console.log(this.value);
                    var defType = $("select[name=defType-" + this.value + "]").val();
                    var defNote = $("input[name=defNote-" + this.value + "]").val();
                    var defName = $(this).data('defname');
                    var defImageSrc = "";
                    if(document.getElementById("defImage-" + this.value) != null) {
                        defImageSrc = document.getElementById("defImage-" + this.value).src;
                        console.log("Image Source : " + defImageSrc);
                    }

                    var defTypeClass = "none";
                    if (defType == "minor") {
                        defTypeClass = "minor";
                        defType = "Minor";
                    } else if (defType == "major") {
                        defTypeClass = "major";
                        defType = "Major";
                    }

                    var html = '<li>' +
                        '<div class="details-block">' +
                            '<div class="details-label first-label">' + defName + '</div>';
                    if (defTypeClass != "none") {
                        html += '<div class="details-notes">' +
                                    '<span class="' + defTypeClass + '">' + defType + '</span>' +
                                '</div>';
                    }

                    html += '</div>';
                    if (defNote != "") {
                        html += '<div class="details-block">' +
                            '<div class="details-label">Defect Details</div>' +
                            '<div class="details-notes">' +
                            defNote
                        '</div>' +
                            '</div>';
                    }

                    if(defImageSrc != "" && !defImageSrc.includes("default")) {
                        html += '<div class="details-block">' +
                            '<div class="details-img">'+
                                '<img src="'+defImageSrc+'">'+
                                '</div>' +
                            '</div>';                        
                    }


                    html += '</li>';
                    //append data into vehicle block
                    $("#trailer_defect_block ul").append(html)

                });

            }

        },
        updateDefectVars: function(defects) {
            defects.show_image_control = true;
            if(!defects.local_image) {
                this.removedImagePaths.push(defects.image);
            }   
            defects.image = "default";
        },
        onFileChange(e,defects) {
            console.log(defects);
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.createImage(e,files[0],defects);
        },
        createImage(input,file,defects) {

            var self = this;
            defects.show_image_control = false;
            defects.local_image = true;

            var MAX_WIDTH  = 400;
            var MAX_HEIGHT = 300;
            
            var image = new Image();
            var reader = new FileReader();
            //var vm = this;

            /*reader.onload = (e) => {
                //vm.image['image-'+id] = e.target.result;
                defects.image = e.target.result;
            };*/

            reader.addEventListener("load", function(event) {

                var origImg = new Image();
                origImg.src = event.target.result;

                origImg.addEventListener("load", function(event) {

                    var width  = event.target.width;
                    var height = event.target.height;


                    // Don't resize if it's small enough

                    if (width <= MAX_WIDTH && height <= MAX_HEIGHT) {
                        var canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;

                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(origImg, 0, 0, width, height);

                        defects.image = canvas.toDataURL();
                        //input.src = resizedFile.getAsDataURL();

                        $('[name="defImageComp-'+defects.id+'"]').remove();
                        //elf.formData.append("defImageComp-"+defects.id, resizedFile, 'sample.png');
                        $('<input>').attr({
                            type: 'hidden',
                            id: 'foo',
                            name: "defImageComp-"+defects.id,
                            value: canvas.toDataURL()//encodeURIComponent(canvas.toDataURL())
                        }).appendTo('form');
                    } else {
                        // Calc new dims otherwise

                        if (width > height) {
                            if (width > MAX_WIDTH) {
                                height *= MAX_WIDTH / width;
                                width = MAX_WIDTH;
                            }
                        } else {
                            if (height > MAX_HEIGHT) {
                                width *= MAX_HEIGHT / height;
                                height = MAX_HEIGHT;
                            }
                        }


                        // Resize

                        var canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;

                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(origImg, 0, 0, width, height);

                        // Uncomment below code to get resized file object.
                        /*
                            ToDo : Send File object instead of base64 string.
                            Wanted to append file object to FormData, but facing issues while appending file object.
                                   So for now we are sending base64 string and converting to file object on Server.

                        */
                        // var resizedFile = self.base64ToFile(canvas.toDataURL(), file);
                        
                        defects.image = canvas.toDataURL();
                        //input.src = resizedFile.getAsDataURL();

                        $('[name="defImageComp-'+defects.id+'"]').remove();
                        //elf.formData.append("defImageComp-"+defects.id, resizedFile, 'sample.png');
                        $('<input>').attr({
                            type: 'hidden',
                            id: 'foo',
                            name: "defImageComp-"+defects.id,
                            value: canvas.toDataURL()//encodeURIComponent(canvas.toDataURL())
                        }).appendTo('form');
                    }
                });
            });

            reader.readAsDataURL(file);
        },
        base64ToFile: function(dataURI, origFile){
            var byteString, mimestring;

            if(dataURI.split(',')[0].indexOf('base64') !== -1 ) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = decodeURI(dataURI.split(',')[1]);
            }

            mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0];

            var content = new Array();
            for (var i = 0; i < byteString.length; i++) {
                content[i] = byteString.charCodeAt(i);
            }

            var newFile = new File(
                [new Uint8Array(content)], origFile.name, {type: mimestring}
            );


            // Copy props set by the dropzone in the original file

            var origProps = [
                "upload", "status", "previewElement", "previewTemplate", "accepted"
            ];

            $.each(origProps, function(i, p) {
                newFile[p] = origFile[p];
            });

            return newFile;
        },
        upload (compressorId) {
            console.log(this.$refs);
            //let compressor = this.$refs[compressorId].$el
            var compressor = document.getElementById(compressorId);
            //console.log(compressor);
            compressor.click()
        },
        getFiles(obj){
            this.img = obj.compressed.blob
            this.original = obj.original
            this.compressed = obj.compressed
            console.log("Compressed Image : " + this.compressed);
        },
        call: function() {
             var self = this;
            var ins_id = window.location.pathname.split('/')[3];

            var url = self.$config.API+"/v1/assets/inspection-detail"

            if (ins_id != undefined) {
                url = self.$config.API+"/v1/assets/inspection-detail?id=" + ins_id
            }
self.$config.loading=true;
        
            $.ajax({
                url: url,
                type: "GET",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },timeout: 30000,
                success: function(res) {self.$config.loading=false;

                    if (res.status == "success") {

                        if (res.data.detail != "" && res.data.detail != null) {
                            console.log(res);
                            self.vin = res.data.vin
                            self.inspectionTime = res.data.detail[0].inspection_time
                            self.company = res.data.detail[0].company
                            self.companyId = res.data.detail[0].company_id
                            self.odometer = res.data.detail[0].odometer
                            self.latitude = res.data.detail[0].latitude
                            self.longitude = res.data.detail[0].longitude
                            self.locationName = res.data.detail[0].location_name
                            if (ins_id != undefined) {
                                self.inspectionType = res.data.detail[0].inspection_type
                            }                            
                            self.id = res.data.detail[0].id
                            self.defect_correction = res.data.detail[0].defect_status

                            self.showDriverSign = true
                            if (typeof res.data.detail[0].driver_sign !== "undefined") {
                                self.signaturePadDriver.fromDataURL(decodeURIComponent(res.data.detail[0].driver_sign))
                                //self.resizeCanvas(document.getElementById("signature-pad-driver"));
                            }
                            if (typeof res.data.detail[0].mechanic_sign !== "undefined") {
                                self.signaturePadMechanic.fromDataURL(decodeURIComponent(res.data.detail[0].mechanic_sign))
                                //self.resizeCanvas(document.getElementById("signature-pad-mechanic"));
                                self.areDefectsAdded = true
                                self.showMechanicSign = true
                            }

                            self.vehicleDefects = res.data.vehicle_defects
                            self.trailerDefects = res.data.trailer_defects
                            
                            /*var i;
                            for (i = 0;i<self.vehicleDefects.length;i++){
                                self.image["image-"+self.vehicleDefects[i].id] = "";
                            }
                            for (i = 0;i<self.trailerDefects.length;i++){
                                self.image["image-"+self.trailer_defects[i].id] = "";
                            }
                            console.log(self.image);*/
                        }

                        if (res.data.selVehDef != "") {
                            self.selVehDefects = res.data.selVehDef
                        }
                        if (res.data.selTraDef != "") {
                            self.selTraDefects = res.data.selTraDef
                        }

                    }
                },
                error: function(jqXHR, exception,textstatus) {self.$config.loading=false;
                    //if session expired
                   if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
                        self.$router.push(
                            "/v1/operator/login"
                        )
                    } else if (jqXHR.responseJSON.code == 400) {
                        alert(jqXHR.responseJSON.message);
                    }

                }
            });
        },
        addInspectionDetail: function() {
            //debugger;
            var self = this;
            //var formData = $("#inspectionForm").serialize();
            //console.log("Form Data : " + formData);
            var driverSignImage = "", mechanicSignImage = "", defectStatus = -1;
            if (self.signaturePadDriver.isEmpty()) {
                alert("Driver Signature required");
                $("#sign_tab").click();
                return;
            }
            defectStatus = $("input[name='opt_defects']:checked").val();
            if (typeof defectStatus === "undefined") {
                defectStatus = -1
            }
            driverSignImage = self.signaturePadDriver.toDataURL("image/png");
            mechanicSignImage = self.signaturePadMechanic.isEmpty() ? "" : self.signaturePadMechanic.toDataURL("image/png"); 
            
            console.log(self.inspectionType);
            //return;
             // Get form
            var serializedReturn = $('#inspectionForm').find('input[type!=file], select').serialize(); 

            var finalJSON =  JSON.stringify(serializedReturn);
            finalJSON += "&inspection_date="+self.selectedDate;
            finalJSON += "&driver_sign="+encodeURIComponent(driverSignImage);
            finalJSON += "&mechanic_sign="+encodeURIComponent(mechanicSignImage);
            finalJSON += "&defect_status="+defectStatus;
            finalJSON += "&removed_image_paths="+self.removedImagePaths;
            console.log(finalJSON);
            finalJSON = finalJSON.substring(1);
            
            self.$config.loading=true;
            $.ajax({
                url: self.$config.API+"/v1/assets/add-inspection-detail",
                type: "POST",
                //processData: false,  // Important!
                /*enctype: 'multipart/form-data',
                processData: false,  // Important!
                contentType: false,
                cache: false,*/
                data: finalJSON,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },timeout: 10000,
                dataType: "json",
                success: function(res) {self.$config.loading=false;

                    if (res.status == "success") {
                        alert(res.message);
                        self.$router.push(
                            "/operator/pre-log-summary?selected_date=" + self.selectedDate+"&from_date=" + self.fromDate + "&to_date=" + self.toDate
                        )
                    }
                },
                error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
                    //debugger;
                    //if session expired
                    if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
                        self.$router.push(
                            "/v1/operator/login"
                        )
                    } else if (jqXHR.responseJSON.code == 400) {
                        alert(jqXHR.responseJSON.message);
                    }

                }
            });
        },
        clearSignature: function(signaturePad) {
            signaturePad.clear();
        },
        getLocationConstant: function(flag) {

            // $(".loading").removeClass("hide");

            var self = this;
            self.$config.loading=true;
            if (navigator.geolocation) {
                var abc = navigator.geolocation.getCurrentPosition(
                    self.onGeoSuccess,
                    self.onGeoError
                );
            } else {
                console.log("No GPS support");
            }
        },
        onGeoSuccess: function(event) {
            var self = this;
            self.longitude = event.coords.longitude;
            self.latitude = event.coords.latitude;
            self.codeLatLong(event.coords.latitude, event.coords.longitude)
        },

        onGeoError: function(event) {
            $(".loading").addClass("hide");
            var self = this;
            self.$config.loading=false;
            console.log("Error code " + event.code + ". " + event.message);

        },
        codeLatLong: function(lat, long) {
            var self = this
            var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(lat, long);
            geocoder.geocode({ 'latLng': latlng }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    console.log(results)
                    if (results[1]) {
                        //formatted address
                        //var address = results[0].formatted_address;
                        self.locationName = results[0].formatted_address;
                        //alert("address = " + address);
                    } else {
                        alert("No results found");
                    }
                } else {
                    alert("Geocoder failed due to: " + status);
                }
            });
            // $(".loading").addClass("hide");
            self.$config.loading=true;
        },
        resizeCanvas : function(canvas) {
            var ratio =  Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
            //this.signaturePadDriver.clear();
            //this.signaturePadMechanic.clear();
        }
    },

};
</script>


// WEBPACK FOOTER //
// src/components/inspection.vue